import draggable from "vuedraggable";
import pipelineStage from '../../../../onboarding/pipeline-stage.js';
import pipelineItem from '../../../../onboarding/pipeline-item.js';

if($('#network-pipelines').length){
    var app = new Vue({
        el: '#network-pipelines',
        data: {
            data: {},
            networkId: networkId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationType: applicationType,
            processing: false,
            loading: false,
            showReOrderStages: false,
            hideStages: true,
            applications: [],
            tour2Active: false,
            tour3Active: false,
            pipelineStage: pipelineStage,
            pipelineItem: pipelineItem,
            tags: [],
            serverParams: {
                tagFilter: ''
            },
            showAddStage: false,
            pipelineType: '',
            filterPipelineType: 'all',
            pipelineOptions: []
        },
        methods: {
            addItemText() {
                if (this.filterPipelineType == 1) {
                    return 'innovation'
                } else if(this.filterPipelineType == 2) {
                    return 'expert'
                } else {
                    return 'solution'
                }
            },
            showDropdown() {
                if (!this.filterPipelineType) {
                    this.showAddStage = true
                } else {
                    this.storeStage();
                }
            },
            getStages(){
                this.applicationType = 'all';
                if (this.filterPipelineType) {
                    if (this.filterPipelineType == 1) {
                        this.applicationType = 'innovation';
                    } else if (this.filterPipelineType == 2) {
                        this.applicationType = 'expert';
                    }
                }
                this.pipelineType = this.filterPipelineType;
                this.updateParams({page: 1});
                this.hideStages = true;
                this.loading = true;
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/stage', {
                    params: {
                        tagId: this.serverParams.tagFilter,
                        pipelineType: this.filterPipelineType
                    }
                }).then((response) =>  {
                    this.data = response.data;
                    this.getDropOptions();
                    this.$nextTick(() => {
                        this.hideStages = false;
                        this.tour2();
                    });
                    this.getApplications();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            storeStage(){
                this.applicationType = 'all';
                if (this.pipelineType) {
                    if (this.pipelineType == 1) {
                        this.applicationType = 'innovation';
                    } else if (this.pipelineType == 2) {
                        this.applicationType = 'expert';
                    }
                }
                this.filterPipelineType = this.pipelineType;
                this.showAddStage = false;
                if(!this.processing){
                    this.processing = true;
                    axios.post('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/stage',{tagId: this.serverParams.tagFilter, type: this.pipelineType})
                        .then((response) =>  {
                            this.data = response.data;
                            this.getDropOptions();
                        this.$nextTick(() => {
                            this.tour2();
                        });
                        this.processing = false;
                        this.$toasted.success('Stage added, please change the name');
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }else{
                    this.$toasted.info('Please wait for previous task to finish processing');
                }
            },
            updateStage(stage, application_type){
                if(!this.processing){
                    this.processing = true;
                    axios.patch('/api/v1/network/'+this.networkSlug+'/'+application_type+'/stage/'+stage.id, {name:stage.name, tagId: this.serverParams.tagFilter, pipelineType: this.filterPipelineType}).then((response) =>  {
                        this.data = response.data;
                        this.getDropOptions();
                        this.processing = false;
                        this.$toasted.success('Stage name updated');
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }else{
                    this.$toasted.info('Please wait for previous task to finish processing');
                }
            },
            destroyStage(stage, application_type){
                if(!stage.items.length){
                    if(confirm("Are you sure you wish to delete this stage?")){
                        axios.delete('/api/v1/network/'+this.networkSlug+'/'+application_type+'/stage/'+stage.id).then(() =>  {
                            this.reorderStages();
                            this.$toasted.success('Stage deleted');
                        }).catch((error) => {
                            this.errorHandler(error);
                        });
                    }
                }else{
                    this.$toasted.error('You must remove all items from this stage before you can delete it');
                }
            },
            reorderStages(data = null){
                this.processing = true;
                var input = null;
                if(data){
                    var array = [];
                    data.forEach((value, index) => {
                        array.push(value.id);
                    });
                }

                axios.patch('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/stage/reorder', {stages: array, tagId: this.serverParams.tagFilter, pipelineType: this.filterPipelineType}).then((response) =>  {
                    this.data = response.data;
                    this.getDropOptions();
                    this.processing = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            editStageName(stage, stageIndex){
                stage.edit = true;
                this.$nextTick(() => {
                    $("#stage-name-"+stageIndex).focus();
                });
            },
            getApplications(){
                this.loading = true;
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/remaining-applications', {
                    params: {
                        tagId: this.serverParams.tagFilter,
                        pipelineType: this.filterPipelineType
                    }
                }).then((response) =>  {
                    this.applications = response.data;
                    this.loading = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            addItem(event, stage, application_type){
                var name = "applications-" + stage.id;
                var type = $('select[name=' + name + '] :selected').attr('class')
                this.processing = true;
                axios.patch('/api/v1/network/'+this.networkSlug+'/'+type+'/stage/'+stage.id+'/item/'+event.target.value, {tagId: this.serverParams.tagFilter, pipelineType: this.filterPipelineType})
                    .then((response) =>  {
                    this.data = response.data;
                        this.getDropOptions();
                    this.processing = false;
                    this.$toasted.success('Application added to stage');
                    $("#applications-"+stage.id).val("");
                    this.$nextTick(() => {
                        this.tour3();
                    });
                    this.getApplications();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            itemChange(event, stage, application_type) {
                if(typeof event.added.element['innovation'] === 'undefined') {
                    var type = 'expert';
                } else {
                    var type = 'innovation';
                }
                this.processing = true;
                var key = Object.keys(event);
                if(key[0] == 'added'){
                    var array = [];
                    stage.items.forEach((value) => {
                        array.push({'id': value.id, 'type': type});
                    });

                    axios.patch('/api/v1/network/'+this.networkSlug+'/'+type+'/stage/'+stage.id+'/item/'+event.added.element.id+'/move',{items: array, tagId: this.serverParams.tagFilter, pipelineType: this.filterPipelineType})
                        .then((response) =>  {
                        this.data = response.data;
                            this.getDropOptions();
                        this.processing = false;
                        this.$toasted.success('Item moved to new stage');
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }
                if(key[0] == 'moved'){
                    var array = [];
                    stage.items.forEach((value) => {
                        array.push({'id': value.id, 'type': type});
                    });

                    axios.patch('/api/v1/network/'+this.networkSlug+'/'+type+'/stage/'+stage.id+'/item/'+event.moved.element.id+'/reorder',{items: array, tagId: this.serverParams.tagFilter, pipelineType: this.filterPipelineType}).then((response) =>  {
                        this.data = response.data;
                        this.getDropOptions();
                        this.processing = false;
                        this.$toasted.success('Item reordered');
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }
            },
            removeItem(item, stage, application_type){
                if(typeof item['innovation'] === 'undefined') {
                    var type = 'expert';
                } else {
                    var type = 'innovation';
                }
                if(confirm("Are you sure you wish to remove this application from the pipeline?")){
                    this.processing = true;
                    var array = [];
                    stage.items.forEach((value) => {
                        if(value.id != item.id){
                            array.push({'id': value.id, 'type': type});
                        }
                    });

                    axios.patch('/api/v1/network/'+this.networkSlug+'/'+type+'/stage/'+stage.id+'/item/'+item.id+'/remove',{items: array, tagId: this.serverParams.tagFilter, pipelineType: this.filterPipelineType}).then((response) =>  {
                        this.data = response.data;
                        this.getDropOptions();
                        this.processing = false;
                        this.$toasted.success('Item removed from stage');
                        this.getApplications();
                    }).catch((error) => {
                        this.errorHandler(error);
                    });
                }
            },
            getUserLabel(item){
                var name = null;
                if(item.user){
                    name = item.user.private ? item.user.organisation : item.user.first_name + ' ' + item.user.last_name
                }

                return name;
            },
            getLabel(item) {
                var name = null;
                if (item.innovation) {
                    name = item.innovation.title
                } else if (item.user) {
                    name = item.user.private ? item.user.organisation : item.user.first_name + ' ' + item.user.last_name
                }
                return name;
            },
            getInnovationLabel(item){
                var name = null;
                if(item.innovation){
                    name = item.innovation.title
                }

                return name;
            },
            tour2(){
                if(this.data.length >= 2 && this.tour2Active == false){
                    this.pipelineStage.tour();
                    this.tour2Active = true;
                }
            },
            tour3(){
                if(this.tour3Active == false){
                    this.pipelineItem.tour();
                    this.tour3Active = true;
                }
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            },
            getTags(){
                axios.get('/api/v1/network/'+this.networkSlug+'/tags').then((response) =>  {
                    this.tags = response.data;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            getResponseColor(id) {
                if (id === 1) {
                    return 'red';
                } else if (id === 2) {
                    return 'orange';
                } else if (id === 3) {
                    return '#7de2a8';
                } else {
                    return '#efefef';
                }
            },
            getDropOptions() {
                this.pipelineOptions = [];
                this.pipelineOptions.push(
                    {'id': 'all', 'name': 'All'},
                    {'id': '1', 'name': 'Innovation'},
                    {'id': '2', 'name': 'Expert'}
                );
            }
        },
        components: {
            'draggable': draggable
        },
        mounted () {
            this.getStages();
            this.getTags();
        }
    });
}